import React from 'react';
import {FormikProps} from 'formik';
import {EvaluationTask} from '@/views/admin/channel/types';

type Props = {
  formik: FormikProps<EvaluationTask>;
};

const EvaluationTaskCallFeaturesFormFields: React.FC<Props> = React.memo(({formik}) => (
    <></>
));

export default EvaluationTaskCallFeaturesFormFields; 